import { render, staticRenderFns } from "./CustomerLayout.vue?vue&type=template&id=fba12618&scoped=true&"
import script from "./CustomerLayout.vue?vue&type=script&lang=js&"
export * from "./CustomerLayout.vue?vue&type=script&lang=js&"
import style0 from "./CustomerLayout.vue?vue&type=style&index=0&id=fba12618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba12618",
  null
  
)

export default component.exports